import { useState, useEffect, useRef } from "react";
import MUIDataTable from "./MuiDataTable";
import {
  Box,
  IconButton,
  Typography,
  Stack,
  TextField,
  Button,
} from "@mui/material";
import {
  MRT_ActionMenuItem,
  MRT_ToggleGlobalFilterButton,
  MRT_ShowHideColumnsButton,
  MRT_ToggleFullScreenButton,
  MRT_ExpandAllButton,
} from "material-react-table";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import UnfoldMoreIcon from "@mui/icons-material/UnfoldMore";
import { Edit, Delete } from "@mui/icons-material";
const CustomListViewSub = ({
  listData,
  columns,
  handleDataFetch,
  totalCount,
  isLoading = false,
}) => {
  const [data, setData] = useState([]);
  // const [isLoading, setIsLoading] = useState(false);
  const [totalRows, setTotalRows] = useState(0);

  // Add all necessary states
  const [columnFilters, setColumnFilters] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState([]);
  const [columnVisibility, setColumnVisibility] = useState({});
  const [rowSelection, setRowSelection] = useState({});
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });

  // const fetchData = async (pageIndex, pageSize) => {
  //   return new Promise((resolve) => {
  //     setTimeout(() => {
  //       const startIndex = pageIndex * pageSize;
  //       const paginatedData = sampleData.slice(startIndex, startIndex + pageSize);

  //       resolve({
  //         data: paginatedData,
  //         totalRows: sampleData.length,
  //       });
  //     }, 500);
  //   });
  // };

  // useEffect(() => {
  //   const loadData = async () => {
  //     setIsLoading(true);
  //     try {
  //       const response = await fetchTableData({
  //         pageIndex: pagination.pageIndex,
  //         pageSize: pagination.pageSize,
  //         filters: columnFilters,
  //         globalSearch: globalFilter,
  //         sorting: sorting
  //       });
  //       setData(response.data);
  //       setTotalRows(response.totalRows);
  //     } catch (error) {
  //       console.error('Error loading data:', error);
  //     } finally {
  //       setIsLoading(false);
  //     }
  //   };

  //   loadData();
  // }, [pagination.pageIndex, pagination.pageSize, columnFilters, globalFilter, sorting]);

  useEffect(() => {
    setTotalRows(totalCount);
    setData(listData);
  }, [listData, totalCount]);

  useEffect(() => {
    handleDataFetch(
      pagination.pageIndex,
      pagination.pageSize,
      columnFilters,
      sorting
    );
    console.log(columnVisibility);
  }, [pagination.pageIndex, pagination.pageSize, sorting, columnVisibility]);
  const firstRender = useRef(true);
  const prevFilters = useRef([]);
  const hadRealSearch = useRef(false);

  // Tracks if user ever performed a valid search (≥3 chars)
  const hadValidSearchEver = useRef(false);

  useEffect(() => {
  if (firstRender.current) {
    firstRender.current = false;
    prevFilters.current = columnFilters;
    return;
  }

  const prevMap = {};
  const currMap = {};

  prevFilters.current.forEach((f) => {
    prevMap[f.id] = (f.value || "").trim();
  });

  columnFilters.forEach((f) => {
    currMap[f.id] = (f.value || "").trim();
  });

  const currValues = Object.values(currMap);

  const hasValidSearchNow = currValues.some((v) => v.length >= 3);

  if (hasValidSearchNow) {
    hadValidSearchEver.current = true;
  }

  const isFullyCleared = columnFilters.length === 0;

  if (isFullyCleared && hadValidSearchEver.current) {
    handleDataFetch(
      pagination.pageIndex,
      pagination.pageSize,
      columnFilters,
      sorting
    );
    prevFilters.current = columnFilters;
    return;
  }

  // NEW LOGIC — run fetch on any valid (>=3) change
  const validSearchChanged = Object.keys(currMap).some((id) => {
    const curr = currMap[id];
    const prev = prevMap[id] ?? "";
    return curr.length >= 3 && curr !== prev;
  });

  // Cleared existing valid search (object still exists)
  const clearedToEmptyAfterValid = Object.keys(prevMap).some(
    (id) => prevMap[id].length >= 3 && currMap[id] === ""
  );

  // Cleared existing valid search (object removed)
  const removedAfterValid = Object.keys(prevMap).some(
    (id) => prevMap[id].length >= 3 && !(id in currMap)
  );

  if (validSearchChanged || clearedToEmptyAfterValid || removedAfterValid) {
    handleDataFetch(
      pagination.pageIndex,
      pagination.pageSize,
      columnFilters,
      sorting
    );
  }

  prevFilters.current = columnFilters;
}, [columnFilters]);

//   useEffect(() => {
//     if (firstRender.current) {
//       firstRender.current = false;
//       prevFilters.current = columnFilters;
//       return;
//     }

//     const prevMap = {};
//     const currMap = {};

//     prevFilters.current.forEach((f) => {
//       prevMap[f.id] = (f.value || "").trim();
//     });

//     columnFilters.forEach((f) => {
//       currMap[f.id] = (f.value || "").trim();
//     });

//     const prevValues = Object.values(prevMap);
//     const currValues = Object.values(currMap);

//     // --- Detect whether valid search exists now ---
//     const hasValidSearchNow = currValues.some((v) => v.length >= 3);

//     // --- If we now have a valid search, mark that valid search has happened ---
//     if (hasValidSearchNow) {
//       hadValidSearchEver.current = true;
//     }

//     // --- CASE 1: Filters fully cleared AFTER a valid search was done before ---
//     const isFullyCleared = columnFilters.length === 0;

//     if (isFullyCleared && hadValidSearchEver.current) {
//       handleDataFetch(
//         pagination.pageIndex,
//         pagination.pageSize,
//         columnFilters,
//         sorting
//       );
//       prevFilters.current = columnFilters;
//       return;
//     }

//     // --- CASE 2: New valid search started ---
//     const newValidSearch = Object.keys(currMap).some(
//       (id) => currMap[id].length >= 3 && (prevMap[id]?.length || 0) < 3
//     );

//     // --- CASE 3: Previous was valid, now cleared to "" (object still exists) ---
//     const clearedToEmptyAfterValid = Object.keys(prevMap).some(
//       (id) =>
//         prevMap[id].length >= 3 &&
//         currMap[id] !== undefined &&
//         currMap[id].length === 0
//     );

//     // --- CASE 4: Previous was valid, now the filter object was removed (MRT removed it) ---
//     const removedAfterValid = Object.keys(prevMap).some(
//       (id) => prevMap[id].length >= 3 && !(id in currMap)
//     );

//     if (newValidSearch || clearedToEmptyAfterValid || removedAfterValid) {
//       handleDataFetch(
//         pagination.pageIndex,
//         pagination.pageSize,
//         columnFilters,
//         sorting
//       );
//     }

//     prevFilters.current = columnFilters;
//   }, [columnFilters]);

  return (
    <MUIDataTable
      columns={columns}
      enableVerticalBorders={false}
      data={data}
      enablePagination={true}
      // enableRowSelection={true}
      enableColumnFilters={true}
      enableGlobalFilter={false}
      enableSorting={true}
      enableEditing={false}
      enableExport={false}
      exportType="csv"
      enableStickyHeader={true}
      isLoading={isLoading}
      renderRowActionMenuItems={({ row, table }) => [
        <MRT_ActionMenuItem //or just use a normal MUI MenuItem component
          icon={<Edit />}
          key="edit"
          label="Edit"
          onClick={() => console.info("Edit")}
          table={table}
        />,
        <MRT_ActionMenuItem
          icon={<Delete />}
          key="delete"
          label="Delete"
          onClick={() => console.info("Delete")}
          table={table}
        />,
      ]}
      onColumnVisibilityChange={setColumnVisibility}
      tableTheme="TenantAdmin"
      icons={{
        ArrowDownwardIcon: (props) => <KeyboardArrowDownIcon {...props} />,
        SyncAltIcon: (props) => (
          <UnfoldMoreIcon
            sx={{ display: "none", fontSize: "medium", ml: "4px" }}
          />
        ),
        DragHandleIcon: (props) => null,
      }}
      // Pass all states
      columnFilters={columnFilters}
      globalFilter={globalFilter}
      sorting={sorting}
      columnVisibility={columnVisibility}
      rowSelection={rowSelection}
      pagination={pagination}
      maxHeight="500px"
      enableInfiniteScroll={true}
      enableRowVirtualization={true}
      // Pass all state handlers

      initialState={{
        pagination: pagination,
        columnFilters: columnFilters,
        globalFilter: globalFilter,
        sorting: sorting,
        rowSelection: rowSelection,
      }}
      onAddNewRow={(row) => console.info("Add new row:", row)}
      onColumnFiltersChange={setColumnFilters}
      onGlobalFilterChange={setGlobalFilter}
      onSortingChange={setSorting}
      // onColumnVisibilityChange={setColumnVisibility}
      onRowSelectionChange={setRowSelection}
      onPaginationChange={setPagination}
      rowCount={totalRows}
      exportRowData
      title="Users"
      muiPaginationProps={{
        rowsPerPageOptions: [5, 10, 20, 50, 100],
      }}
      renderBottomToolbarCustomActions={({ table }) => (
        <>
          <Typography
            variant="body1"
            sx={{
              fontSize: "0.875rem",
              fontWeight: 500,
              color: "#374151",
            }}
          >
            {/* Total: {table.getRowCount()} */}
            Count: {table.getRowModel().rows.length}
          </Typography>
        </>
      )}
    />
  );
};

export default CustomListViewSub;
